import { css } from '@emotion/react'
import common from 'shared/styles'
import custom from 'shared/styles/custom.styles'

const styles = () => {
    return {
        code: css`
            ${custom.stepElementPadding};
            font-weight: bold;
        `,
        text: css`
            ${custom.stepText};
        `,
        actions: css`
            ${common.flexJustityAlignCenter};
            padding: 0;
        `,
        button: css`
            width: auto !important;
            margin: 20px 25px;
            padding: 10px 20px;
            ${custom.button};
        `,
    }
}

export default styles
